import BackgroundInformation from './BackgroundInformation'

export default BackgroundInformation
